export enum PaymentStatus {
    Pending = 1,
    Paid = 2,
    Expired = 3,
    Cancelled = 4
}